
                import { Component,  Vue } from 'vue-property-decorator';
                import 'bootstrap';
                import 'bootstrap/dist/css/bootstrap.min.css';
                import API from '@/store/api';
               // import { useCookies } from "vue3-cookies";
                @Component
                export default class Header extends Vue {

                    private isAutheticated: any = 'false';
                    private base = '';
                    private tag = '';
                    private tagadd = '';
                    private files = '';
                    private filesadd = '';
                    private users = '';
                    private usersadd = '';
                    private homefilesadd = '';
                    private logout = '';
                    private footerImages = '';
                    private footerImagesadd = '';

                    private async mounted() {
                        this.base = process.env.VUE_APP_MYBASE_URL;
                        this.tag = process.env.VUE_APP_MYBASE_URL + '/Tags';
                        this.tagadd = process.env.VUE_APP_MYBASE_URL + '/Tags/Add';
                        this.files = process.env.VUE_APP_MYBASE_URL + '/Files';
                        this.filesadd = process.env.VUE_APP_MYBASE_URL + '/Files/Add';
                        this.users = process.env.VUE_APP_MYBASE_URL + '/Users';
                        this.usersadd = process.env.VUE_APP_MYBASE_URL + '/Users/Add';
                        this.homefilesadd = process.env.VUE_APP_MYBASE_URL + '/headerfiles/addheaderfile';
                        this.footerImages = process.env.VUE_APP_MYBASE_URL + '/FooterImages';
                        this.footerImagesadd = process.env.VUE_APP_MYBASE_URL + '/FooterImages/add';
                        this.logout = process.env.VUE_APP_MYBASE_URL + '/auth/logout';
                                              
                      
                       
                    }

                    private async created() {

                        this.isAutheticated = API.isAuthenticated().then(my_bool => {
                            //alert(my_bool);
                            this.isAutheticated = my_bool;
                        });
                        
                    }
                }
            